/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Starred_OnlyInputs */



/**
* | output |
* | --- |
* | "Starred only" |
*
* @param {Explorer_Search_Starred_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_starred_only = /** @type {((inputs?: Explorer_Search_Starred_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Starred_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Starred only")
	if (locale === "de") return /** @type {LocalizedString} */ ("Starred only")
	if (locale === "it") return /** @type {LocalizedString} */ ("Starred only")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Starred only")
	if (locale === "es") return /** @type {LocalizedString} */ ("Starred only")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Starred only")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Starred only")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Starred only")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Starred only")
	return /** @type {LocalizedString} */ ("Starred only")
});